import { Home } from "./pages/Home/Home";
import Contact from "./pages/Contact/Contact";
import Detail from "./pages/Detail/Detail";
import DRDetail from './pages/DRDetail/DRDetail';
import Contents from "./pages/Contents/Contents";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/Contact',
        element: <Contact />
    },
    {
        path: '/Detail',
        element: <Detail />
    },
    {
        path: '/Content/:contentType/:slug',
        element: <Detail />
    },
    {
        path: '/DRDetail/:stockSymbol',
        element: <DRDetail />
    },
    {
        path: '/Contents',
        element: <Contents />
    }
];

export default AppRoutes;
